import { Popover } from '@mui/material';
import { isEqual, sortBy } from 'lodash';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import CrossIcon from '../../../assets/svg/CrossIcon';
import { Button, Checkbox } from '../../Shared';

export const TeamFilter = ({
  callerIds,
  onChangeCallerIds,
  managerTeam,
  isManagerTeamLoading,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currCallerIds, setCurrCallerIds] = useState(callerIds);

  const onChangeCurrCallerIds = callerId => {
    setCurrCallerIds(prev => {
      const isSelected = prev.includes(callerId);

      if (isSelected) return prev.filter(v => v !== callerId);

      return [...prev, callerId];
    });
  };

  const onChange = () => {
    onChangeCallerIds(prev => {
      return {
        ...prev,
        callerIds: currCallerIds,
      };
    });
    onClosePopover();
  };

  const reset = () => {
    onChangeCallerIds(prev => {
      return {
        ...prev,
        callerIds: [],
      };
    });
  };

  const onOpenPopover = e => {
    if (e.target.localName !== 'button') return;
    setCurrCallerIds(callerIds);
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const hasTeam = callerIds.length > 0;
  const isButtonApplyDisabled = isEqual(
    sortBy(callerIds),
    sortBy(currCallerIds),
  );

  return (
    <>
      <button
        className={twMerge(
          'flex items-center gap-2 rounded-full py-[11px] px-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
          hasTeam && 'bg-brand-900 text-white !pl-6 !pr-5',
        )}
        onClick={onOpenPopover}
        disabled={isManagerTeamLoading}
      >
        {hasTeam ? `Team +${callerIds.length}` : 'Team'}
        {hasTeam && (
          <div onClick={reset}>
            <CrossIcon className="w-4 h-4 text-white" />
          </div>
        )}
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[260px]',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="overflow-hidden">
          <div className="p-1 flex flex-col gap-1 max-h-[268px] overflow-auto">
            {managerTeam.map(({ name, FullName }) => {
              const checked = currCallerIds.includes(name);

              return (
                <label
                  key={name}
                  className="flex items-center gap-2 py-1 px-1 cursor-pointer rounded-lg hover:bg-brand-300/[0.08]"
                >
                  <Checkbox
                    checked={checked}
                    onChange={() => {
                      onChangeCurrCallerIds(name);
                    }}
                  />
                  <span className="text-[16px]/[24px] text-base-1000 truncate">
                    {FullName}
                  </span>
                </label>
              );
            })}
          </div>
          <div className="px-4 py-3 border-t border-t-base-200">
            <Button
              title="Apply"
              onClick={onChange}
              disabled={isButtonApplyDisabled}
              className="ml-auto"
            />
          </div>
        </div>
      </Popover>
    </>
  );
};
